import React, { PropsWithChildren } from 'react'
import { Dimensions, Platform, StatusBar, StyleProp, View, ViewStyle } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { globalStyle } from '../../theme/global'
import { corporateColor } from '../../theme/colors'
import { LogoutBigIcon } from '../LogoutBigIcon/LogoutBigIcon'

const widthScreen = Dimensions.get('window').width

interface Props extends PropsWithChildren {
  styleContent?: StyleProp<ViewStyle>
  header?: boolean
  title?: string
  backButtonFunction?: () => void
}
export const TemplatePage = ({
  children,
  styleContent,
  header,
  title,
  backButtonFunction,
}: Props) => {
  const width = widthScreen * 0.7
  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: corporateColor }}>
      <StatusBar barStyle='light-content' backgroundColor={'#2D3E4A'} />

      {header && (
        <LogoutBigIcon
          backButton
          notificationsHeader
          title={title}
          backButtonFunction={backButtonFunction}
        />
      )}

      <View
        style={[
          globalStyle.contentContainer,
          {
            maxWidth: 830,
            ...(width > 700 ? { marginLeft: 'auto', marginRight: 'auto' } : {}),
          },

          styleContent,
          {
            ...(Platform.OS === 'web' ? { minWidth: 300, maxWidth: 600, width: '100%' } : {}),
          },
        ]}
      >
        {children}
      </View>
    </SafeAreaView>
  )
}
